import React, { useContext, useState } from 'react';
import InputField from '../../lib/ui/inputs/Input';
import { LangCtx, PayLoadCtx } from "../../lib/context";
import Button from "../../lib/ui/buttons/Button";

import "../doctor/doctorSettings/doctorSettings.css";
import "../../ui-styles/animations/ripple.css";
import "../../ui-styles/buttons/ButtonFilled.css";
import "../../ui-styles/buttons/ButtonTxt.css";
import "../doctor/doctorSchedules/Schedules.css";
import { toast } from 'react-toastify';
import { Auth } from 'aws-amplify';
import { changepasword, getPrevent, postPrevent } from '../../actions/users';
// import config from "../../config.json";
import { validatePassword } from "../../lib/validation";
import md5 from 'md5';
import Loader from '../../lib/ui/loader/Loader';


const ChangePassword = (props) => {
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    // const currentRef = useRef(null);
    const [currentPwd, setCurrentPwd] = useState("");
    const [newPwd, setNewPwd] = useState("");
    const [confirmPwd, setConfirmPwd] = useState("");
    const [errorMsg, setErrorMsg] = useState(null);
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);


    const chkPrevPassword = async () => {
        try {
            const res = await getPrevent();
            if (res?.status) {
                return verifyNewPassWithLastThreePass(res.data.prevReuse) ? verifyNewPassWithLastThreePass(res.data.prevReuse) : false;
            }
            return false;
        } catch (e) {
            return false;
        }
    }


    const verifyNewPassWithLastThreePass = (data) => {
        let convertNewPass = md5(newPwd);
        return data.includes(convertNewPass);
    }
    const handleSave = async () => {
        setLoader(true)
        let resFromApi = await chkPrevPassword();
        let _errors = {}

        if (!currentPwd || (currentPwd && currentPwd.trim() === "")) {
            _errors['currentPwd'] = l.ent_curr_pwd;
        }
        if (!newPwd || (newPwd && newPwd.trim() === "")) {
            _errors['newPwd'] = l.ent_new_pwd;
        }
        if (!validatePassword(newPwd)) {
            _errors['newPwd'] = l.ent_valid_pwd
        }
        if (confirmPwd !== newPwd) {
            _errors['confirmPwd'] = l.new_conf_match;
        }
        // console.log("error == ", _errors, Object.keys(_errors).length);
        if (resFromApi) {
            let _errors = {
                newPwd: "Your New Password cannot be the same as any of your last three passwords. Please choose a different password"
            };
            setErrors({ ..._errors });
            toast.error('Your New Password cannot be the same as any of your last three passwords. Please choose a different password', {
                position: toast.POSITION.TOP_RIGHT
            })
            setLoader(false);
            return;
        }
        if (Object.keys(_errors).length === 0) {
            setErrors({ currentPwd: '', newPwd: '' })
            if (process.env.REACT_APP_isOffline === "true") {
                const body = {
                    currentPwd: currentPwd,
                    newPwd: newPwd
                }
                changepasword(body).then(res => {
                    setLoader(false)
                    setCurrentPwd('');
                    setNewPwd('');
                    setConfirmPwd('');
                    setErrorMsg(null)
                    toast.success(l.pwd_upd_succ, {
                        position: toast.POSITION.TOP_RIGHT
                    })
                }).catch(err => {
                    console.log("error in change password=====", err);
                    let _errors = {};
                    if (err.code === "NotAuthorizedException") {
                        _errors = {
                            newPwd: "Incorrect password"
                        }
                    } else {
                        setErrorMsg(err.message)
                    }
                    setErrors({ ..._errors });
                    setLoader(false)
                })
            } else {

                try {
                    let session = await Auth.currentSession()
                    let token = session.getAccessToken().getJwtToken();
                    // console.log('.........:', token);
                    await postPrevent({ id: md5(newPwd), sub: payload.userId, type: "change", token: token, newPwd: newPwd, currentPwd: currentPwd }).then(res => {
                        if (res.status) {
                            setLoader(false)
                            setCurrentPwd('');
                            setNewPwd('');
                            setConfirmPwd('');
                            setErrorMsg(null)
                            toast.success(l.pwd_upd_succ, {
                                position: toast.POSITION.TOP_RIGHT
                            })
                        } else {
                            toast.error('Your New Password cannot be the same as any of your last three passwords. Please choose a different password', {
                                position: toast.POSITION.TOP_RIGHT
                            })
                        }
                    }).catch((e) => {
                        console.log('................,l,', e);
                        if(e.response && e.response.data && e.response.data.error !== ''){
                            setErrorMsg(e.response.data.error);
                        }else{
                            setErrorMsg('Attempt limit exceeded, please try after some time');
                        }
                        
                        setLoader(false)
                    })
                } catch (err) {
                    console.log(err);
                    let _errors = {};
                    if (err.code === "NotAuthorizedException") {
                        _errors = {
                            currentPwd: "The current password you have entered is incorrect"
                        }
                    } else {
                        setErrorMsg(err.message)
                    }
                    setErrors({ ..._errors });
                    setLoader(false)
                }
                // if (res.status) {
                //     Auth.currentAuthenticatedUser()
                //         .then(user => {
                //             return Auth.changePassword(user, currentPwd, newPwd);
                //         })
                //         .then(async data => {
                //             // console.log(data);                        
                //             setLoader(false)
                //             setCurrentPwd('');
                //             setNewPwd('');
                //             setConfirmPwd('');
                //             setErrorMsg(null)
                //             toast.success(l.pwd_upd_succ, {
                //                 position: toast.POSITION.TOP_RIGHT
                //             })
                //         })
                //         .catch(err => {
                //             console.log(err);
                //             let _errors = {};
                //             if (err.code === "NotAuthorizedException") {
                //                 _errors = {
                //                     currentPwd: "The current password you have entered is incorrect"
                //                 }
                //             } else {
                //                 setErrorMsg(err.message)
                //             }
                //             setErrors({ ..._errors });
                //             setLoader(false)
                //         });
                // } else {
                //     toast.error('Your New Password cannot be the same as any of your last three passwords. Please choose a different password', {
                //         position: toast.POSITION.TOP_RIGHT
                //     })
                // }
            }
        } else {
            setErrors({ ..._errors });
            setLoader(false);
        }
    }

    const handleCancel = () => {
        setCurrentPwd('');
        setNewPwd('');
        setConfirmPwd('');
        setErrors({ currentPwd: '', newPwd: '' })
    }

    return (
        <div className="listContainer">
            <div className="colBlock">
                <div className="setngHeadingBox pdT16">
                    <p className="subDescTxt nopdng">{l.chng_pwd_desc}</p>
                </div>
                <div className="rowBlock cpwdSetngForm">

                    <div className="inputFormList">
                        {errorMsg && errorMsg !== "" && <div className="errorBox">
                            <small className="errorTxt">{errorMsg}</small>
                        </div>
                        }
                        <div className="cpwdInputItem">
                            <InputField
                                placeholder={l.currnt_pwd}
                                type="password"
                                value={currentPwd}
                                maxLength="30"
                                onChange={(e) => setCurrentPwd(e.target.value)}
                                error={errors && errors.currentPwd && errors.currentPwd !== ""}
                                errorMsg={errors.currentPwd}
                                showPwd={true}
                            />
                        </div>
                        <div className="cpwdInputItem">
                            <InputField
                                placeholder={l.new_pwd}
                                type="password"
                                value={newPwd}
                                maxLength="30"
                                onChange={(e) => setNewPwd(e.target.value)}
                                error={errors && errors.newPwd && errors.newPwd !== ""}
                                errorMsg={errors.newPwd}
                                showPwd={true}
                            />
                        </div>
                        <div className="cpwdInputItem">
                            <InputField
                                placeholder={l.conf_new_pwd}
                                type="password"
                                value={confirmPwd}
                                maxLength="30"
                                onChange={(e) => setConfirmPwd(e.target.value)}
                                error={errors && errors.confirmPwd && errors.confirmPwd !== ""}
                                errorMsg={errors.confirmPwd}
                                showPwd={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="btnGroup pdng08 respFlexPos">
                    <Button
                        label={l.save}
                        size="md"
                        type="primary"
                        onClick={handleSave}
                    />
                    {(currentPwd !== '' || newPwd !== '' || confirmPwd !== '') && <Button
                        label={l.cancel}
                        size="md"
                        type="outLine"
                        onClick={handleCancel}
                    />}
                    {/* <button className="btnFilled md ripple" onClick={handleSave}>
                        <span>{l.save}</span>
                    </button>
                    <button type="outLine" className="btnFilled md ripple avoidClick overLay">
                        <span>{l.cancel}</span>
                    </button> */}
                </div>
            </div>
            {loader && <Loader />}
        </div>
    )
}

export default ChangePassword;